import {
  SEARCH_INPUT_SOURCING_FILTER1_BUYER,
  SEARCH_OPTION_SOURCING_FILTER2_BUYER,
  SEARCH_OPTION_SOURCING_FILTER3_BUYER,
  SEARCH_OPTION_SOURCING_FILTER4_BUYER,
  SEARCH_OPTION_SOURCING_FILTER5_BUYER,
} from './constants'

export const filterSearchSourcingInput1 = (search = '', enterEvent = null) => ({
  type: SEARCH_INPUT_SOURCING_FILTER1_BUYER,
  searchValue: search,
  enterSearchInputFilter: enterEvent,
})
export const filterSearchSourcingOptions2 = (
  search = '0',
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_FILTER2_BUYER,
  searchOption2: search,
  selectedOptions2: selectSearchOption,
})
export const filterSearchSourcingOptions3 = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_FILTER3_BUYER,
  searchOption3: search,
  selectedOptions3: selectSearchOption,
})
export const filterSearchSourcingOptions4 = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_FILTER4_BUYER,
  searchOption4: search,
  selectedOptions4: selectSearchOption,
})
/* seal status */
export const filterSearchSourcingOptions5 = (
  search = 0,
  selectSearchOption = null
) => ({
  type: SEARCH_OPTION_SOURCING_FILTER5_BUYER,
  searchOption5: search,
  selectedOptions5: selectSearchOption,
})
